import {createFileRoute} from '@tanstack/react-router';

import DiagnosticReportSent from '@/patient/views/DiagnosticReportSent';

export const Route = createFileRoute('/(patient)/patient/diagnostic-report-sent')({
  component: DiagnosticReportSent
});
